/**
 * Haptic feedback utility using the Web Vibration API.
 * Falls back silently on unsupported browsers/devices.
 */
function vibrate(pattern: number | number[]): void {
  try {
    navigator.vibrate?.(pattern);
  } catch {
    // Silently ignore — unsupported browser
  }
}

export const haptic = {
  /** Light tap — 12ms. For nav switches, likes, downloads, tab/category changes. */
  light: () => vibrate(12),
  /** Medium tap — 25ms. For apply/set wallpaper, long-press, confirm purchase. */
  medium: () => vibrate(25),
  /** Success pattern — for completed purchases, uploads, confirmations. */
  success: () => vibrate([15, 50, 15]),
  /** Error pattern — for failed operations and permission denials. */
  error: () => vibrate([50, 30, 50]),
};
